import type { Product, ProductCategory, SalesCategory, ServiceCategory } from '@/types';

export const PRODUCT_CATEGORIES = [
  'tires',
  'used_tires',
  'wheels',
  'used_wheels',
  'batteries',
  'lubes_fluids',
  'filters',
  'accessories',
  'consumables',
  'services',
  'other',
] as const satisfies readonly ProductCategory[];

export const SALE_PRODUCT_CATEGORIES = [
  'tires',
  'used_tires',
  'wheels',
  'used_wheels',
  'batteries',
  'lubes_fluids',
  'filters',
  'accessories',
  'consumables',
  'other',
] as const satisfies readonly ProductCategory[];

export const REPORTING_CATEGORIES = [
  'tires',
  'used_tires',
  'wheels',
  'used_wheels',
  'tire_service',
  'accessories',
  'consumables',
  'batteries',
  'lubes_fluids',
  'filters',
  'services',
  'other',
] as const satisfies readonly SalesCategory[];

export const isTireCategory = (category: ProductCategory) =>
  category === 'tires' || category === 'used_tires';

export const isUsedCategory = (category: ProductCategory) =>
  category === 'used_tires' || category === 'used_wheels';

export const isLowStockProduct = (
  product: Pick<Product, 'current_stock' | 'min_stock_level'>,
) => product.min_stock_level > 0 && product.current_stock <= product.min_stock_level;

export const normalizeProductCategory = (category: string): ProductCategory => {
  if (category === 'oils') return 'lubes_fluids';
  return PRODUCT_CATEGORIES.includes(category as ProductCategory)
    ? (category as ProductCategory)
    : 'other';
};

export const getProductSalesCategory = (category: ProductCategory): SalesCategory =>
  category === 'services' ? 'services' : category;

export const getServiceSalesCategory = (category: ServiceCategory): SalesCategory =>
  category === 'tire_service' ? 'tire_service' : 'services';

export const normalizeSalesCategory = (category?: string | null): SalesCategory => {
  if (category === 'oils') return 'lubes_fluids';
  return REPORTING_CATEGORIES.includes(category as SalesCategory)
    ? (category as SalesCategory)
    : 'other';
};
